<template>
  <div class="sc-message--text" 
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me'
      }">
    <p class="markdown-css" v-html="convertMarkdownToHtml(data)"></p>
    
  </div>
</template>

<script>
import marked from 'marked';

export default {
  data() {
    return {
      messageShow: ''
    };
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    multipleType: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    data() {
      if(this.multipleType) {
        var contentData = {}
        contentData = JSON.parse(this.message.msgJson)
        // 多 type 抓取的欄位
        // 處理 超連結 和 email
        this.$set(contentData, 'text', contentData.text)
        return contentData.text
      } else {
      var contentData = {}
      contentData = JSON.parse(JSON.stringify(this.message))
        // 單一訊息抓取的欄位
        // 處理 超連結 和 email
        this.$set(contentData.data, 'text', contentData.data.text)
        return contentData.data.text
      }
    }
  },
  methods: {
    convertMarkdownToHtml(markdown) {
      let html = markdown.replace(/~/g, '-')
      return marked(html)
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/beautiful-chat/MarkDownTextMessage.vue